// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor_panel_stimulus-layout .options-new-question .container-body-new-resource {\n  background-color: var(--background2);\n  padding: 0px;\n  width: auto; }\n", ""]);
// Exports
module.exports = exports;
